<template>
  <div class="content comparador" v-if="rendered">
    <card class="text-left mt-5 pr-3 pl-3">
      <div class="row">
        <div class="col-lg-4">
          <h4 slot="header" class="card-title"><b>1.</b> Filtrar Datas</h4>
        </div>
        <div class="col-lg-4" v-if="comparar">
          <h4 slot="header" class="card-title"><b>2.</b> Comparar com:</h4>
        </div>
        <div class="col-lg-4" v-if="comparar"></div>
      </div>
      <div class="row">
        <div class="col-lg-4">
          <base-input>
            <el-date-picker
              type="daterange"
              range-separator="a"
              start-placeholder="Data início"
              end-placeholder="Data fim"
              v-model="dateRange"
              @change="onDateChange"
            >
            </el-date-picker>
          </base-input>
        </div>

        <div class="col-lg-4">
          <div v-if="comparar">
            <div class="row">
              <div class="col-lg-6">
                <el-select
                  class="select-primary"
                  size="large"
                  placeholder="Outras datas"
                  v-model="filtrado"
                  @change="compararSelect"
                >
                  <el-option
                    class="select-primary"
                    value="mesmo_periodo"
                    label="Período Anterior"
                  >
                  </el-option>
                  <el-option
                    class="select-primary"
                    value="custom"
                    label="Costumizado"
                  >
                  </el-option>
                </el-select>
              </div>
              <div class="col-md-6">
                <el-select
                  class="select-primary"
                  size="large"
                  placeholder="Campanhas"
                  :disabled="campanhas.length == 0"
                  v-model="campanhaSelecionada"
                  @change="compararSelectCampanha"
                >
                  <el-option
                    v-for="(campanha, i) in campanhas"
                    :key="i"
                    class="select-primary"
                    :value="campanha.titulo"
                    :label="campanha.titulo"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
          <div v-if="filtrado == 'custom'">
            <div class="row mt-3">
              <base-input>
                <el-date-picker
                  type="daterange"
                  range-separator="a"
                  start-placeholder="Data início"
                  end-placeholder="Data fim"
                  v-model="dateRangeCustom"
                  @change="onDateChangeCustom"
                >
                </el-date-picker>
              </base-input>
            </div>
          </div>
        </div>
        <div class="col-lg-4 text-center" v-if="comparar">
          <div class="col-lg-12 text-center" style="display: inline-block;">
            <base-button
              style="height: 45px;margin: 0;"
              native-type="submit"
              type="primary"
              size="sm"
              block
              @click="submit"
            >
              Submeter
            </base-button>
          </div>
        </div>
      </div></card
    >

    <div class="row g-3" v-if="comparadorReady">
      <div class="col-lg-6 text-left">
        <card class="mr-1">
          <div class="row mt-3 p-2 pl-5 pr-5">
            <h2>
              <i
                class="tim-icons icon-molecule-40 icon-verde-gerencia-cor"
                style="color:red"
              ></i
              ><span class="ml-3 text-left">Visitas</span>
            </h2>
            <div class="col-lg-6">
              <div class="col-lg-12 text-left pl-0">
                <span v-if="filtrado == 'custom'" class="bold"
                  >{{ formatDate(dateRangeCustom[0]) }} a
                  {{ formatDate(dateRangeCustom[1]) }}</span
                >
                <span v-if="filtrado == 'mesmo_periodo'" class="bold"
                  >{{ formatDate(previousRange[0]) }} a
                  {{ formatDate(previousRange[1]) }}</span
                >
                <span v-if="campanhaSelecionada != ''" class="bold"
                  >{{ campanhaSelecionada }}
                  <span class="dataPequena"
                    >({{ formatDate(dateRangeCampanha[0]) }} a
                    {{ formatDate(dateRangeCampanha[1]) }})</span
                  ></span
                >
              </div>
              <card
                class="mt-3"
                style="box-shadow: 0 1px 15px 0 rgba(123, 123, 123, 0.2) !important;"
              >
                <div class="col-lg-12 text-center">
                  <p
                    class="BigPercentage"
                    :class="
                      comparadorVisitas[0].tipo == 'positivo'
                        ? 'verdePositivo'
                        : comparadorVisitas[0].tipo == 'negativo'
                        ? 'vermelhoNegativo'
                        : 'neutro'
                    "
                  >
                    {{ comparadorVisitas[0].valorPercentagem }}
                  </p>
                  <h4>{{ comparadorVisitas[0].valor }} visitas</h4>
                </div>
              </card>
            </div>
            <div class="col-lg-6">
              <div class="col-lg-12 text-left pl-0">
                <span class="bold"
                  >{{ formatDate(dateRange[0]) }} a
                  {{ formatDate(dateRange[1]) }}</span
                >
              </div>
              <card
                class="mt-3"
                style="box-shadow: 0 1px 15px 0 rgba(123, 123, 123, 0.2) !important;"
              >
                <div class="col-lg-12 text-center">
                  <p
                    class="BigPercentage"
                    :class="
                      comparadorVisitas[1].tipo == 'positivo'
                        ? 'verdePositivo'
                        : comparadorVisitas[1].tipo == 'negativo'
                        ? 'vermelhoNegativo'
                        : 'neutro'
                    "
                  >
                    {{ comparadorVisitas[1].valorPercentagem }}
                  </p>
                  <h4>{{ comparadorVisitas[1].valor }} visitas</h4>
                </div>
              </card>
            </div>
          </div>
        </card>
      </div>
      <div class="col-lg-6 text-left">
        <card class="ml-1">
          <div class="row mt-3 p-2 pl-5 pr-5">
            <h2>
              <i
                class="tim-icons icon-delivery-fast  icon-verde-gerencia-cor"
                style="color:red"
              ></i
              ><span class="ml-3 text-left">Visitas Únicas</span>
            </h2>
            <div class="col-lg-6">
              <div class="col-lg-12 text-left pl-0">
                <span v-if="filtrado == 'custom'" class="bold"
                  >{{ formatDate(dateRangeCustom[0]) }} a
                  {{ formatDate(dateRangeCustom[1]) }}</span
                >
                <span v-if="filtrado == 'mesmo_periodo'" class="bold"
                  >{{ formatDate(previousRange[0]) }} a
                  {{ formatDate(previousRange[1]) }}</span
                >
                <span v-if="campanhaSelecionada != ''" class="bold"
                  >{{ campanhaSelecionada }}
                  <span class="dataPequena"
                    >({{ formatDate(dateRangeCampanha[0]) }} a
                    {{ formatDate(dateRangeCampanha[1]) }})</span
                  ></span
                >
              </div>
              <card
                class="mt-3"
                style="box-shadow: 0 1px 15px 0 rgba(123, 123, 123, 0.2) !important;"
              >
                <div class="col-lg-12 text-center">
                  <p
                    class="BigPercentage"
                    :class="
                      comparadorVisitasUnicas[0].tipo == 'positivo'
                        ? 'verdePositivo'
                        : comparadorVisitasUnicas[0].tipo == 'negativo'
                        ? 'vermelhoNegativo'
                        : 'neutro'
                    "
                  >
                    {{ comparadorVisitasUnicas[0].valorPercentagem }}
                  </p>
                  <h4>{{ comparadorVisitasUnicas[0].valor }} visitas únicas</h4>
                </div>
              </card>
            </div>
            <div class="col-lg-6">
              <div class="col-lg-12 text-left pl-0">
                <span class="bold"
                  >{{ formatDate(dateRange[0]) }} a
                  {{ formatDate(dateRange[1]) }}</span
                >
              </div>
              <card
                class="mt-3"
                style="box-shadow: 0 1px 15px 0 rgba(123, 123, 123, 0.2) !important;"
              >
                <div class="col-lg-12 text-center">
                  <p
                    class="BigPercentage"
                    :class="
                      comparadorVisitasUnicas[1].tipo == 'positivo'
                        ? 'verdePositivo'
                        : comparadorVisitasUnicas[1].tipo == 'negativo'
                        ? 'vermelhoNegativo'
                        : 'neutro'
                    "
                  >
                    {{ comparadorVisitasUnicas[1].valorPercentagem }}
                  </p>
                  <h4>{{ comparadorVisitasUnicas[1].valor }} visitas únicas</h4>
                </div>
              </card>
            </div>
          </div>
        </card>
      </div>
    </div>
    <div class="row g-3" v-if="comparadorReady">
      <div class="col-lg-6 text-left">
        <card class="mr-1">
          <div class="row mt-3 p-2 pl-5 pr-5">
            <h2>
              <i
                class="tim-icons icon-cart  icon-verde-gerencia-cor"
                style="color:red"
              ></i
              ><span class="ml-3 text-left">Faturação Total</span>
            </h2>
            <div class="col-lg-6">
              <div class="col-lg-12 text-left pl-0">
                <span v-if="filtrado == 'custom'" class="bold"
                  >{{ formatDate(dateRangeCustom[0]) }} a
                  {{ formatDate(dateRangeCustom[1]) }}</span
                >
                <span v-if="filtrado == 'mesmo_periodo'" class="bold"
                  >{{ formatDate(previousRange[0]) }} a
                  {{ formatDate(previousRange[1]) }}</span
                >
                <span v-if="campanhaSelecionada != ''" class="bold"
                  >{{ campanhaSelecionada }}
                  <span class="dataPequena"
                    >({{ formatDate(dateRangeCampanha[0]) }} a
                    {{ formatDate(dateRangeCampanha[1]) }})</span
                  ></span
                >
              </div>
              <card
                class="mt-3"
                style="box-shadow: 0 1px 15px 0 rgba(123, 123, 123, 0.2) !important;"
              >
                <div class="col-lg-12 text-center">
                  <p
                    class="BigPercentage"
                    :class="
                      comparadorFaturacaoTotal[0].tipo == 'positivo'
                        ? 'verdePositivo'
                        : comparadorFaturacaoTotal[0].tipo == 'negativo'
                        ? 'vermelhoNegativo'
                        : 'neutro'
                    "
                  >
                    {{ comparadorFaturacaoTotal[0].valorPercentagem }}
                  </p>
                  <h4>{{ comparadorFaturacaoTotal[0].valor }} €</h4>
                </div>
              </card>
            </div>
            <div class="col-lg-6">
              <div class="col-lg-12 text-left pl-0">
                <span class="bold"
                  >{{ formatDate(dateRange[0]) }} a
                  {{ formatDate(dateRange[1]) }}</span
                >
              </div>
              <card
                class="mt-3"
                style="box-shadow: 0 1px 15px 0 rgba(123, 123, 123, 0.2) !important;"
              >
                <div class="col-lg-12 text-center">
                  <p
                    class="BigPercentage"
                    :class="
                      comparadorFaturacaoTotal[1].tipo == 'positivo'
                        ? 'verdePositivo'
                        : comparadorFaturacaoTotal[1].tipo == 'negativo'
                        ? 'vermelhoNegativo'
                        : 'neutro'
                    "
                  >
                    {{ comparadorFaturacaoTotal[1].valorPercentagem }}
                  </p>
                  <h4>{{ comparadorFaturacaoTotal[1].valor }} €</h4>
                </div>
              </card>
            </div>
          </div>
        </card>
      </div>
      <div class="col-lg-6 text-left">
        <card class="ml-1">
          <div class="row mt-3 p-2 pl-5 pr-5">
            <h2>
              <i
                class="tim-icons icon-coins  icon-verde-gerencia-cor"
                style="color:red"
              ></i
              ><span class="ml-3 text-left">Ticket Médio</span>
            </h2>
            <div class="col-lg-6">
              <div class="col-lg-12 text-left pl-0">
                <span v-if="filtrado == 'custom'" class="bold"
                  >{{ formatDate(dateRangeCustom[0]) }} a
                  {{ formatDate(dateRangeCustom[1]) }}</span
                >
                <span v-if="filtrado == 'mesmo_periodo'" class="bold"
                  >{{ formatDate(previousRange[0]) }} a
                  {{ formatDate(previousRange[1]) }}</span
                >
                <span v-if="campanhaSelecionada != ''" class="bold"
                  >{{ campanhaSelecionada }}
                  <span class="dataPequena"
                    >({{ formatDate(dateRangeCampanha[0]) }} a
                    {{ formatDate(dateRangeCampanha[1]) }})</span
                  ></span
                >
              </div>
              <card
                class="mt-3"
                style="box-shadow: 0 1px 15px 0 rgba(123, 123, 123, 0.2) !important;"
              >
                <div class="col-lg-12 text-center">
                  <p
                    class="BigPercentage"
                    :class="
                      comparadorTicketMedio[0].tipo == 'positivo'
                        ? 'verdePositivo'
                        : comparadorTicketMedio[0].tipo == 'negativo'
                        ? 'vermelhoNegativo'
                        : 'neutro'
                    "
                  >
                    {{ comparadorTicketMedio[0].valorPercentagem }}
                  </p>
                  <h4>{{ comparadorTicketMedio[0].valor }} €</h4>
                </div>
              </card>
            </div>
            <div class="col-lg-6">
              <div class="col-lg-12 text-left pl-0">
                <span class="bold"
                  >{{ formatDate(dateRange[0]) }} a
                  {{ formatDate(dateRange[1]) }}</span
                >
              </div>
              <card
                class="mt-3"
                style="box-shadow: 0 1px 15px 0 rgba(123, 123, 123, 0.2) !important;"
              >
                <div class="col-lg-12 text-center">
                  <p
                    class="BigPercentage"
                    :class="
                      comparadorTicketMedio[1].tipo == 'positivo'
                        ? 'verdePositivo'
                        : comparadorTicketMedio[1].tipo == 'negativo'
                        ? 'vermelhoNegativo'
                        : 'neutro'
                    "
                  >
                    {{ comparadorTicketMedio[1].valorPercentagem }}
                  </p>
                  <h4>{{ comparadorTicketMedio[1].valor }} €</h4>
                </div>
              </card>
            </div>
          </div>
        </card>
      </div>
    </div>
  </div>
  <div v-else>
    <div class="loading-overlay">
      <span class="fas fa-spinner fa-3x fa-spin"></span>
    </div>
  </div>
</template>
<script>
import swal from "sweetalert2";
import { Select, Option, DatePicker } from "element-ui";
import api from "../api/index";
import { Modal, BaseInput, Card } from "@/components/index";
import StatsCard from "../components/Cards/StatsCard.vue";
const today = new Date();
export default {
  components: {
    Modal,
    Card,
    BaseInput,
    StatsCard,
    [Option.name]: Option,
    [Select.name]: Select,
  },
  data() {
    return {
      rendered: false,
      comparar: false,
      comparadorReady: false,
      events: [],
      campanhas: [],
      campanhaSelecionada: "",
      admin: "0",
      restaurante: "",
      dateRange: [],
      dateRangeCustom: [],
      dateRangeCampanha: [],
      previousRange: [],
      filtrado: "",
      comparadorVisitas: [
        {
          valorPercentagem: "0",
          tipo: "",
          valor: 0,
        },
        {
          valorPercentagem: "0",
          tipo: "",
          valor: 0,
        },
      ],
      comparadorVisitasUnicas: [
        {
          valorPercentagem: "0",
          tipo: "",
          valor: 0,
        },
        {
          valorPercentagem: "0",
          tipo: "",
          valor: 0,
        },
      ],
      comparadorFaturacaoTotal: [
        {
          valorPercentagem: "0",
          tipo: "",
          valor: 0,
        },
        {
          valorPercentagem: "0",
          tipo: "",
          valor: 0,
        },
      ],
      comparadorTicketMedio: [
        {
          valorPercentagem: "0",
          tipo: "",
          valor: 0,
        },
        {
          valorPercentagem: "0",
          tipo: "",
          valor: 0,
        },
      ],
    };
  },
  watch: {
    dateRange(newVal) {
      if (!newVal) {
        this.comparar = false;
        this.comparadorReady = false;
        return;
      } else if (newVal && newVal.length == 0) {
        this.comparar = false;
        this.comparadorReady = false;
        return;
      }
      this.comparar = true;
    },
  },
  methods: {
    formatDate(dateString) {
      // Cria um objeto de data a partir da string fornecida
      const date = new Date(dateString);

      // Obtém o dia, mês e ano
      const day = String(date.getDate()).padStart(2, "0"); // Adiciona zero à esquerda se necessário
      const month = String(date.getMonth() + 1).padStart(2, "0"); // Mês começa do zero
      const year = date.getFullYear();

      // Retorna a data formatada no formato DD/MM/YYYY
      return `${day}/${month}/${year}`;
    },
    async submit() {
      var json = {};
      if (this.filtrado == "mesmo_periodo") {
        if (this.dateRange.length < 2 || this.previousRange.length < 2) {
          this.notifyVue(
            "top",
            "right",
            "warning",
            "Tem de preencher todos os campos"
          );
          return;
        }
        json = {
          restaurante: this.restaurante,
          dataEscolhida: this.dateRange,
          dataPeriodo: this.previousRange,
        };
      } else if (this.filtrado == "custom") {
        if (this.dateRange.length < 2 || this.dateRangeCustom.length < 2) {
          this.notifyVue(
            "top",
            "right",
            "warning",
            "Tem de preencher todos os campos"
          );
          return;
        }
        json = {
          restaurante: this.restaurante,
          dataEscolhida: this.dateRange,
          dataPeriodo: this.dateRangeCustom,
        };
      } else if (this.filtrado == "" && this.campanhaSelecionada != "") {
        if (this.dateRange.length < 2 || this.dateRangeCampanha.length < 2) {
          this.notifyVue(
            "top",
            "right",
            "warning",
            "Tem de preencher todos os campos"
          );
          return;
        }
        json = {
          restaurante: this.restaurante,
          dataEscolhida: this.dateRange,
          dataPeriodo: this.dateRangeCampanha,
        };
      }
      let res = await api.buscarDadosComparador(json);
      var resultado_anterior = Object.values(res.resultado_anterior);
      var resultado_atual = Object.values(res.resultado_atual);
      if (resultado_anterior.length == 0 || resultado_atual.length == 0) {
        this.notifyVue(
          "top",
          "right",
          "warning",
          "Não há resultado no periodo selecionado."
        );
        this.comparadorReady = false;
        return;
      }

      // VISITAS
      let anteriorVisitas = resultado_anterior.length;
      let atualVisitas = resultado_atual.length;

      let percentagem = 0;

      if (anteriorVisitas > 0) {
        percentagem =
          ((atualVisitas - anteriorVisitas) / anteriorVisitas) * 100;
      }

      this.comparadorVisitas = [
        {
          valorPercentagem: "",
          tipo: "",
          valor: anteriorVisitas.toFixed(0).toString(),
        },
        {
          valorPercentagem: "",
          tipo: "",
          valor: atualVisitas.toFixed(0).toString(),
        },
      ];

      if (atualVisitas > anteriorVisitas) {
        this.comparadorVisitas[0].tipo = "negativo";
        this.comparadorVisitas[0].valorPercentagem = `-${Math.abs(
          percentagem
        ).toFixed(2)}%`;

        this.comparadorVisitas[1].tipo = "positivo";
        this.comparadorVisitas[1].valorPercentagem = `+${Math.abs(
          percentagem
        ).toFixed(2)}%`;
      } else if (anteriorVisitas > atualVisitas) {
        this.comparadorVisitas[0].tipo = "positivo";
        this.comparadorVisitas[0].valorPercentagem = `+${Math.abs(
          percentagem
        ).toFixed(2)}%`;

        this.comparadorVisitas[1].tipo = "negativo";
        this.comparadorVisitas[1].valorPercentagem = `-${Math.abs(
          percentagem
        ).toFixed(2)}%`;
      } else {
        this.comparadorVisitas[0].tipo = "neutro";
        this.comparadorVisitas[0].valorPercentagem = `0%`;

        this.comparadorVisitas[1].tipo = "neutro";
        this.comparadorVisitas[1].valorPercentagem = `0%`;
      }

      //VISITAS UNCIAS

      let nifsUnicosAnteriores = this.obterNifsUnicos(resultado_anterior);
      let nifsUnicosAtuais = this.obterNifsUnicos(resultado_atual);

      let anteriorVisitasUnicas = nifsUnicosAnteriores.length;
      let atualVisitasUnicas = nifsUnicosAtuais.length;

      let percentagemVisitasUnicas = 0;

      if (anteriorVisitasUnicas > 0) {
        percentagemVisitasUnicas =
          ((atualVisitasUnicas - anteriorVisitasUnicas) /
            anteriorVisitasUnicas) *
          100;
      }

      this.comparadorVisitasUnicas = [
        {
          valorPercentagem: "",
          tipo: "",
          valor: anteriorVisitasUnicas.toFixed(0).toString(),
        },
        {
          valorPercentagem: "",
          tipo: "",
          valor: atualVisitasUnicas.toFixed(0).toString(),
        },
      ];

      if (atualVisitasUnicas > anteriorVisitasUnicas) {
        this.comparadorVisitasUnicas[0].tipo = "negativo";
        this.comparadorVisitasUnicas[0].valorPercentagem = `-${Math.abs(
          percentagemVisitasUnicas
        ).toFixed(2)}%`;

        this.comparadorVisitasUnicas[1].tipo = "positivo";
        this.comparadorVisitasUnicas[1].valorPercentagem = `+${Math.abs(
          percentagemVisitasUnicas
        ).toFixed(2)}%`;
      } else if (anteriorVisitasUnicas > atualVisitasUnicas) {
        this.comparadorVisitasUnicas[1].tipo = "negativo";
        this.comparadorVisitasUnicas[1].valorPercentagem = `-${Math.abs(
          percentagemVisitasUnicas
        ).toFixed(2)}%`;

        this.comparadorVisitasUnicas[0].tipo = "positivo";
        this.comparadorVisitasUnicas[0].valorPercentagem = `+${Math.abs(
          percentagemVisitasUnicas
        ).toFixed(2)}%`;
      } else {
        this.comparadorVisitasUnicas[0].tipo = "neutro";
        this.comparadorVisitasUnicas[0].valorPercentagem = `0%`;

        this.comparadorVisitasUnicas[1].tipo = "neutro";
        this.comparadorVisitasUnicas[1].valorPercentagem = `0%`;
      }

      // Somar os valores para os dados anteriores e atuais
      let totalFaturacaoAnterior = this.somarValores(resultado_anterior);
      let totalFaturacaoAtual = this.somarValores(resultado_atual);
      let percentagemFaturacao = 0;

      if (totalFaturacaoAnterior > 0) {
        percentagemFaturacao =
          ((totalFaturacaoAtual - totalFaturacaoAnterior) /
            totalFaturacaoAnterior) *
          100;
      }

      this.comparadorFaturacaoTotal = [
        {
          valorPercentagem: "",
          tipo: "",
          valor: totalFaturacaoAnterior.toFixed(2).toString(),
        },
        {
          valorPercentagem: "",
          tipo: "",
          valor: totalFaturacaoAtual.toFixed(2).toString(),
        },
      ];

      if (totalFaturacaoAtual > totalFaturacaoAnterior) {
        this.comparadorFaturacaoTotal[0].tipo = "negativo";
        this.comparadorFaturacaoTotal[0].valorPercentagem = `-${Math.abs(
          percentagemFaturacao
        ).toFixed(2)}%`;

        this.comparadorFaturacaoTotal[1].tipo = "positivo";
        this.comparadorFaturacaoTotal[1].valorPercentagem = `+${Math.abs(
          percentagemFaturacao
        ).toFixed(2)}%`;
      } else if (totalFaturacaoAnterior > totalFaturacaoAtual) {
        this.comparadorFaturacaoTotal[1].tipo = "negativo";
        this.comparadorFaturacaoTotal[1].valorPercentagem = `-${Math.abs(
          percentagemFaturacao
        ).toFixed(2)}%`;

        this.comparadorFaturacaoTotal[0].tipo = "positivo";
        this.comparadorFaturacaoTotal[0].valorPercentagem = `+${Math.abs(
          percentagemFaturacao
        ).toFixed(2)}%`;
      } else {
        this.comparadorFaturacaoTotal[0].tipo = "neutro";
        this.comparadorFaturacaoTotal[0].valorPercentagem = `0%`;

        this.comparadorFaturacaoTotal[1].tipo = "neutro";
        this.comparadorFaturacaoTotal[1].valorPercentagem = `0%`;
      }

      // Calcular o ticket médio
      let percentagemTicketMedio = 0;
      let ticketMedioAnterior =
        totalFaturacaoAnterior / resultado_anterior.length;
      let ticketMedioAtual = totalFaturacaoAtual / resultado_atual.length;
      if (ticketMedioAnterior > 0) {
        percentagemTicketMedio =
          ((ticketMedioAtual - ticketMedioAnterior) / ticketMedioAnterior) *
          100;
      }
      // Comparação do ticket médio

      this.comparadorTicketMedio = [
        {
          valorPercentagem: "",
          tipo: "",
          valor: ticketMedioAnterior.toFixed(2).toString(),
        },
        {
          valorPercentagem: "",
          tipo: "",
          valor: ticketMedioAtual.toFixed(2).toString(),
        },
      ];
      if (ticketMedioAtual > ticketMedioAnterior) {
        this.comparadorTicketMedio[0].tipo = "negativo";
        this.comparadorTicketMedio[0].valorPercentagem = `-${Math.abs(
          percentagemTicketMedio
        ).toFixed(2)}%`;

        this.comparadorTicketMedio[1].tipo = "positivo";
        this.comparadorTicketMedio[1].valorPercentagem = `+${Math.abs(
          percentagemTicketMedio
        ).toFixed(2)}%`;
      } else if (ticketMedioAnterior > ticketMedioAtual) {
        this.comparadorTicketMedio[1].tipo = "negativo";
        this.comparadorTicketMedio[1].valorPercentagem = `-${Math.abs(
          percentagemTicketMedio
        ).toFixed(2)}%`;

        this.comparadorTicketMedio[0].tipo = "positivo";
        this.comparadorTicketMedio[0].valorPercentagem = `+${Math.abs(
          percentagemTicketMedio
        ).toFixed(2)}%`;
      } else {
        this.comparadorTicketMedio[0].tipo = "neutro";
        this.comparadorTicketMedio[0].valorPercentagem = `0%`;

        this.comparadorTicketMedio[1].tipo = "neutro";
        this.comparadorTicketMedio[1].valorPercentagem = `0%`;
      }

      this.comparadorReady = true;
    },
    somarValores(data) {
      return data.reduce((total, item) => total + parseFloat(item.valor), 0);
    },
    obterNifsUnicos(dados) {
      let nifsUnicos = new Set();
      dados.forEach((item) => nifsUnicos.add(item.nif));
      return Array.from(nifsUnicos);
    },
    notifyVue(verticalAlign, horizontalAlign, color, mensagem) {
      this.$notify({
        icon: "tim-icons icon-bell-55",
        message: mensagem,
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: color,
        timeout: 2000,
      });
    },
    compararSelect(val) {
      this.dateRangeCampanha = [];
      this.campanhaSelecionada = "";
      if (val === "mesmo_periodo" && this.dateRange.length > 0) {
        this.dateRangeCustom = [];
        this.comparadorReady = false;
        const startDate = this.dateRange[0];
        const endDate = this.dateRange[1];
        const diffInMs = endDate - startDate;
        const diffInDays = diffInMs / (1000 * 60 * 60 * 24);

        const previousStartDate = new Date(startDate);
        previousStartDate.setDate(startDate.getDate() - diffInDays - 1);

        const previousEndDate = new Date(endDate);
        previousEndDate.setDate(endDate.getDate() - diffInDays - 1);
        this.previousRange = [previousStartDate, previousEndDate];
      } else if (val === "custom" && this.dateRange.length > 1) {
        this.comparadorReady = false;
        return;
      } else {
        return;
      }
    },
    onDateChange(val) {
      if (val && val.length === 2) {
        var startDate = new Date(val[0]);
        startDate.setMinutes(startDate.getDay() + 1);
        let endDate = new Date(val[1]);
        endDate.setHours(23, 59, 59, 999);

        this.dateRange = [startDate, endDate];

        this.compararSelect(this.filtrado);
      }
    },
    onDateChangeCustom(val) {
      if (val && val.length === 2) {
        var startDate = new Date(val[0]);
        startDate.setMinutes(startDate.getDay() + 1);
        let endDate = new Date(val[1]);
        endDate.setHours(23, 59, 59, 999);

        this.dateRangeCustom = [startDate, endDate];

        this.compararSelect(this.filtrado);
      }
    },
    compararSelectCampanha(val) {
      this.filtrado = "";
      this.dateRangeCampanha = [];
      this.dateRangeCustom = [];
      this.dateRangeCampanha.push(
        new Date(this.campanhas.find((x) => x.titulo == val).data_inicio)
      );
      this.dateRangeCampanha.push(
        new Date(this.campanhas.find((x) => x.titulo == val).data_fim)
      );
    },
    async inicio() {
      this.rendered = false;
      var user = JSON.parse(localStorage.getItem("appGerenciaLogin"));
      let resUser = await api.listarRestaurante({
        user_id: user.user_id,
      });
      var json = {
        restaurante: resUser.resultado.nome,
        admin: "0",
      };
      let res = await api.listarEventos(json);
      var eventos = Object.values(res.resultado);
      this.campanhas = eventos;
      this.restaurante = resUser.resultado.nome;
      this.rendered = true;
    },
  },
  async mounted() {
    await this.inicio();
  },
};
</script>
<style>
.el-loading-spinner .path {
  stroke: #66615b !important;
}
</style>
